import { AiPurchaseOrderContent, type AiPurchaseOrderContentProps } from './components/AiPurchaseOrderContent/AiPurchaseOrderContent'
import { AiPurchaseOrderPageShell } from './components/AiPurchaseOrderPageShell/AiPurchaseOrderPageShell'

export type AiPurchaseOrderProps = AiPurchaseOrderContentProps

export const AiPurchaseOrder = (props: AiPurchaseOrderProps) => (
  <AiPurchaseOrderPageShell>
    <AiPurchaseOrderContent {...props} />
  </AiPurchaseOrderPageShell>
)
